module.exports = __webpack_public_path__ + "static/media/square_logo.839617c5.svg";